import { AxiosResponse } from 'axios';
import api from '../utils/api';
import { BasketLoadEvent, BasketLoadEventResponse } from '../types';

export const basketValidation = async (
  basketLoadEvent: BasketLoadEvent
): Promise<AxiosResponse<BasketLoadEventResponse>> => {
  return api.post('/event/OnBasketLoad', basketLoadEvent);
};
